import React from 'react';

const AddButtonContext = React.createContext(null);

export default AddButtonContext;
